<template>
<div>

	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page-heading -->
		<page-heading show="false" :showBack="true" :pageTitle="'HEADER-'+siteTitle"></page-heading>

        <div class="columns">

			<div class="col-main">

				<div class="box">

					<template v-for="(category, index) in siteCatalogContentCategories" v-if="inCategory(category.id)">

						<div :id="category.name" class="control groupTitle" v-if="!isSupplement">
							<div class="control-label">
								<lang :labelKey="'APO_CATEGORY-'+category.name"></lang>
							</div>
						</div>

						<div :class="['columns', { 'is-multiline is-preview' : previews[index] } ]">

							<div :class="['column', previews[index] ? 'is-12': 'is-narrow']">

								<template v-for="customization in siteCatalog.siteCatalogCustomizations" v-if="customization.type == category.data.catalogPageCustomization">

									<div :class="['previewWrapper', category.name]" @click="doPreview(index)">

										<div class="bgLayer">
											<i class="icon-ak-suche"></i>
										</div>

										<div v-if="customization.preview != null" :class="index">
											<div v-if="customization.preview != null" class="preview lazyImg lazy-img-fadein" v-lazy:background-image="getImgUrl(customization)"></div>
										</div>

										<div v-else class="preview noImg"></div>

									</div>

								</template>

							</div>

							<div class="column">

								<div class="control">
									<div class="control-label">
										<label-name labelKey="APO-UPLOAD_BOX-LABEL"></label-name>
									</div>
									<div class="control">

										<vue-dropzone
											:ref="'vueDropzone'+category.id"
											:id="'vueDropzone'+index"
											url= "fileProcessing/upload?preset=siteCatalogAsset"
			              	:maxFiles="25"
											:isEnabled="!isDisabled"
											:formDataAppend = "[{ category: category.id }]"
				              dictDefaultMessage="<i class='fa fa-cloud-upload'></i>hochladen"
					            v-on:vdropzone-success="dzSuccess($event, category.id)"
											dzClass="default">
										</vue-dropzone>

									</div>
								</div>

								<template v-if="siteCatalog.siteCatalogAssets.length > 0">

									<div class="control is-horizontal">
										<div class="control">
											<assets :assets="siteCatalog.siteCatalogAssets" :isReadOnly="isDisabled" :specialCondition="true" :conditionId="category.id" @removeAsset="removeImageAsset($event, category.id)"></assets>
										</div>
									</div>

								</template>

								<!-- textbox -->
								<div class="control topMargin is-clearfix">
						            <div class="control-label">
						                <label-name :labelKey="category && category.name == 'U4' ? 'APO-NEW_CONTENT_FIELD-U4' : 'APO-NEW_CONTENT_FIELD'"></label-name>
						            </div>
						            <div class="control">
						                <textarea :class="[{'is-disabled': isDisabled }, 'textarea is-medium']" type="text" v-model="textFields[index]"></textarea>
							        </div>
									<div class="control">
										<button :class="[{'is-loading': isSaving, 'is-disabled': isDisabled }, 'button is-normal is-pulled-right']" @click="addContentField(category.id, index)">{{ $t('APO_VIEW-TEXTBOX_ADD') }}</button>
									</div>
						        </div>

								<!-- Text Fields -->
								<content-segment
									:catalogContents="siteCatalog.siteCatalogContents"
									:categoryId="category.id"
									:isDisabled="isDisabled"
									@addTextBox="addContentField"
									@removeTextBox="removeContentField"
									v-model="siteCatalog">
								</content-segment>

							</div>

						</div>


					</template>

				</div>


				<!-- comments -->
				<comments headerTitle="APO_DETAIL-COMMENTS_HEADER" :threadID.sync="currentSiteCatalogCustomization.thread" :api="'siteCatalogCustomization/'+currentSiteCatalogCustomization.id"></comments>

            </div>


            <div class="col-aside">

                <affix :offset="50">

                    <div class="sidebox">

                        <custom-button type="blue" icon="icon-ak-speichern" name="PHARMACY-PAGE_BUTTON-SAVE" :loading="isSaving" @click.native="submitForm(false, true)" :disabled="isDisabled">
						<span style="font-size:10px;">und zurück zur Übersicht</span></custom-button>

						<a :href="downloadURL" :download="downloadName" v-if="currentSiteCatalogCustomization.preview != null">
							<custom-button type="dark" icon="icon-ak-download" name="PDF"></custom-button>
						</a>

					</div>

                </affix>

            </div>


        </div>

    </template>

</div>


</template>



<script>
import contentSegment from './EditMutationSegment';
import vue2Dropzone from '../../utils/dropzoneWrapper'
import assets from '../../utils/incl-assets';
import comments from '../../utils/incl-comments';
export default {

  components: {
		vueDropzone: vue2Dropzone,
		contentSegment,
		comments,
		assets
  },

  data(){
		return {

			// isPreview: false,
			previews: {},
			isLoading: false,
			isSaving: false,
			dzHeaders: { "Cache-Control": "", "X-Requested-With": "", "Authorization": 'Basic ' + localStorage.getItem('token')},
			dzLangObj: {
				dictDefaultMessage: 'Datei wählen oder per Drag & Drop hinzufügen',
				dictCancelUpload: 'abbrechen',
				dictRemoveFile: 'x'
		 	},
			textFields: [],
			// textField: '',
			taxonomies: [],
			currentSiteCatalogCustomization: {},
			siteCatalogContent: [],
			siteCatalogAsset: [],
			siteCatalogCustomization: {},
			siteCatalog: {},
			siteCatalogCats: [],
			siteTitle: null
		}
	},

	computed: {

		isSupplement() {
			return this.$store.getters.getCurrentCatalog.hasCustomizationModeSupplement;
		},

		isDisabled() {
			return ['NONE', 'APPROVAL_REQUESTED', 'PRINT_APPROVAL_REQUESTED', ].indexOf(this.siteCatalog.status.name) == -1;
		},

		siteCatalogContentCategories() {
            return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CONTENT_CATEGORIES');
        },

		siteCatalogCustomizations() {
			return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CUSTOMIZATIONS');
		},

		siteCatalogCustomizationStatus() {
			return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CUSTOMIZATION_STATUS');
		},

		siteCatalogContentsComputed() {
			return this.siteCatalog.siteCatalogContents;
		},

		downloadName() {
			let preview = this.currentSiteCatalogCustomization.preview;
			return this.siteCatalog.site.extRef + '-' + preview.filename.split('.').shift().split('-').pop() + '.pdf';
		},

		downloadURL() {

			var asset = this.$config.assets + this.currentSiteCatalogCustomization.preview.path + '/' + this.currentSiteCatalogCustomization.preview.filename;
			return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";

		},

	},

	created() {

		// set site title
		this.siteTitle = this.$route.params.catID;

		// fetch data
		this.fetchData();

  },

	mounted() {


	},

  methods: {

		doPreview(index) {

			if(this.previews[index] == 'undefined') {
				this.$set(this.previews, index, false);
			}
			this.$set(this.previews, index, !this.previews[index]);
		},

		getAssets(assets, catId) {

			return assets.filter(asset => asset.category == catId);

		},

		getImgUrl(customization) {
			return this.$config.assets +  customization.preview.path + '/' +  customization.preview.filename;
		},

		getPdfDownloadUrl(customization) {

			var asset = this.getImgUrl(customization);
			return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";

		},


		// add and remove content Fields
		// ---------------------------------------------------------------------
		addContentField(catId, index) {

			if(this.isDisabled) {
				this.$notify.open({content: 'Der Status dieser Seite wurde bereits auf "Freigegeben" gesetzt. Eine Änderung ist nicht mehr möglich!', type: 'warning'});
				return false;
			}
			if(typeof this.textFields[index] == 'undefined' || this.textFields[index].length < 3) {
				this.$notify.open({content: 'Bitte geben Sie mindestens drei Zeichen ein!', type: 'warning'});
				return;
			}

			let saveObj = {
				content: this.textFields[index],
				category: catId,
				siteCatalog: this.siteCatalog.id
			}

			this.siteCatalog.siteCatalogContents.push(saveObj);
			this.textFields[index] = '';

			this.submitForm();

		},

		removeContentField(index) {

			this.siteCatalog.siteCatalogContents.splice(index, 1);
			this.submitForm();

		},

		contentFieldLabel(index) {
			return "Text " + ++index;
		},

		inCategory(catId) {

			if(this.siteCatalogCats.indexOf(catId) != -1) {
				return true;
			}

			return false;

		},


		dzSuccess(file, catId) {

			var result = JSON.parse(file.xhr.response);

			var newAsset = {
				category: catId,
				siteCatalog: this.siteCatalog.id,
				asset: {
					filename: result.fileName,
					path: result.dir
				}
			}

			// push newly created obj into assets Array
			this.siteCatalog.siteCatalogAssets.push(newAsset);

			// remove image from dropzone after some time
			var x = this.$refs['vueDropzone'+catId][0].$children[0];
			setTimeout(function() {
				x.removeFile(file);
			}, 1200)


			this.submitForm();

		},

		removeImageAsset(asset, catId) {

			let assetIndex = this.siteCatalog.siteCatalogAssets.findIndex(as => as.asset.filename == asset.asset.filename);
			this.siteCatalog.siteCatalogAssets.splice(assetIndex,1);

			this.submitForm();

		},

		submitForm(isSilent=true, redirect=false) {

			for(var key in this.textFields) {

				if(this.textFields[key] != "" && this.textFields[key].length > 3) {

					let saveObj = {
						content: this.textFields[key],
						category: this.siteCatalogContentCategories[key].id,
						siteCatalog: this.siteCatalog.id
					}

					this.siteCatalog.siteCatalogContents.push(saveObj);
					this.textFields[key] = '';

				}
			}

			var self = this;
            this.entityCreateOrUpdate('siteCatalog', this.siteCatalog, {isSilent: isSilent}).then(function() {
				if(redirect) {
					self.$router.go(-1);
				}
			})

		},


		getCurrentSiteCatalogCustomizationThreadId(customizations) {

			for(var i = 0; i < customizations.length; i++) {
				if(customizations[i].type == this.siteCatalogCustomizations[this.$route.params.catID].id) {
					this.currentSiteCatalogCustomization = customizations[i];
					break;
				}
			}

		},


		fetchData() {

			this.isLoading = true;

			var self = this;
			// siteCatalogID = this.$route.params.siteCatalogID;
			var siteCatalogID = this.$store.getters.getUser.site.id;

			var cats = [];
      switch(this.$route.params.catID) {

          case "U1_U4":
              cats.push(this.siteCatalogContentCategories.U1.id,this.siteCatalogContentCategories.U4.id);
              break;

          case "U2":
              cats.push(this.siteCatalogContentCategories.U2.id);
              break;

          case "US":
              cats.push(this.siteCatalogContentCategories.US_PAGE_1.id, this.siteCatalogContentCategories.US_PAGE_2.id);
              break;
					default:
							cats.push(this.siteCatalogContentCategories[this.$route.params.catID].id)
        }

			this.siteCatalogCats = cats;
			var catsList = cats.join();

			this.entitiesGet([
				{
					key: 'taxonomy',
					params: {
						'filters[name]': ['SITE_CATALOG_CUSTOMIZATION_PACKAGES', 'SITE_CATALOG_CUSTOMIZATION_EXPENSES', 'SITE_CATALOG_CUSTOMIZATIONS', 'SITE_CATALOG_CONTENT_CATEGORIES'].join(','),
						'include': 'taxonomy.taxonomyTerms',
					}
				},
				{
					key: 'siteCatalog',
					params: {
						'filters[catalog.isActive]': 1,
						'filters[siteCatalog.site.id]': siteCatalogID,
						'include': [
							'siteCatalog.siteCatalogAssets',
							'siteCatalog.siteCatalogContents',
							'siteCatalog.site',
							'siteCatalog.siteCatalogCustomizations',
							'siteCatalog.catalog',
							'siteCatalogAsset.asset',
							'siteCatalog.voucherPreview',
							'siteCatalogCustomization.preview',
							'siteCatalog.status'
						].join(',')
					}
				}
			])
				.then(function(results) {

					var i;

					self.siteCatalog = results.siteCatalog[0];
					self.getCurrentSiteCatalogCustomizationThreadId(results.siteCatalog[0].siteCatalogCustomizations);

					// convert taxonomies result to hash table for easy access
					self.taxonomies = self.createTaxonomiesHashTable(results.taxonomy);

					// prepare siteCatalogCustomization if necessary
					// we need to make sure we have three entries of the types U1_U4, U2 and US
					// these types are provided by the SITE-CATALOG-CUSTOMIZATIONS taxonomy
					Object.keys(self.taxonomies.SITE_CATALOG_CUSTOMIZATIONS).forEach(function(key) {

						// check if a customization of this type already exists, otherwise create one
						var siteCatalogCustomizationType = self.taxonomies.SITE_CATALOG_CUSTOMIZATIONS[key],
							exists = self.siteCatalog.siteCatalogCustomizations.filter(function(siteCatalogCustomization) {

								return siteCatalogCustomization.type == siteCatalogCustomizationType.id;

							}).length > 0;

						if (!exists) {

							self.siteCatalog.siteCatalogCustomizations.push({
								siteCatalog: self.siteCatalog.id,
								changeExpendituresAmount: self.taxonomies.SITE_CATALOG_CUSTOMIZATION_EXPENSES.NONE,
								type: siteCatalogCustomizationType.id
							});

						}

					});

				});

		}


    }

}

</script>

<style>

	.control.topMargin {
		margin-top: 50px !important;
	}

	/* @overwrite */
	.control.comments .smallView.commentsContainer {
		margin-top: 5px !important;
		padding: 0;
		width: 100%;
	}
	.control.comments .NewComment .control {
		margin-bottom: 5px !important;
	}

</style>

<style scoped>

	.previewWrapper {
		position: relative;
		margin-right: 5px;
		width: 20vw;
		height: 20vw;
		min-height: 200px;
		min-width: 200px;
		cursor: pointer;
		transition: all .5s ease-in-out;
	}
	.preview {
		position: absolute;
		background-repeat: no-repeat;
		background-position: left;
	    top: 0; left: 0; right:0; bottom:0;
	    width: 100%;
		height: 100% !important;
		overflow: hidden;
		border-radius: 2px;
	}

	.previewWrapper .bgLayer {
		position: absolute;
		z-index: 99;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		background: rgba(255,255,255,0.8);
		display: flex;
		justify-content: center;
		align-items: center;
		visibility: hidden;
	    opacity: 0;
	    transition: visibility .4s, opacity .4s ease;
	}
	.previewWrapper .bgLayer i {
		font-size: 2.8vw;
		color: #666;
	}

	.previewWrapper:hover .bgLayer {
		visibility: visible;
		opacity: 1;
	}
	.is-preview .previewWrapper {
		width: 60vw;
		height: 60vw;
		margin: 0 auto;
	}

	.is-preview .control .control-label {
		text-align: center;
	}
	.is-preview .control .control, .is-preview >>> .control .control {
		margin: 0 auto !important;
		max-width: 800px;
	}

	>>> .control .textarea.is-medium {
		line-height: 24px !important;
	}


	.previewWrapper.US_PAGE_1,
	.previewWrapper.US_PAGE_2 {
		/*height: 37vw;*/
	}
	.previewWrapper.U1 .preview,
	.previewWrapper.US_PAGE_1 .preview {
		background-size: 200% auto;
		background-position: 0 0;
	}
	.previewWrapper.U2 .preview {
		background-size: 100% auto;
		background-position: 0 0;
	}
	.previewWrapper.U4 .preview,
	.previewWrapper.US_PAGE_2 .preview {
		background-size: 200% auto;
		background-position: right top;
	}

	.previewWrapper.INDIVIDUAL_PAGE_1 .preview,
	.previewWrapper.INDIVIDUAL_PAGE_2 .preview,
	.previewWrapper.INDIVIDUAL_PAGE_3 .preview,
	.previewWrapper.INDIVIDUAL_PAGE .preview,
	.previewWrapper.PERSONAL_MESSAGE .preview,
	.previewWrapper.RESPONSE_CONTACT_CARD .preview,
	.previewWrapper.RESPONSE_CARD_LARGE .preview,
	.previewWrapper.RESPONSE_CARD_FRONT .preview,
	.previewWrapper.RESPONSE_CARD_BACK .preview,
	.previewWrapper.CONTACT_CARD .preview {
		background-position: 50%;
		background-size: contain;
	}



	.previewWrapper .preview.noImg,
	.previewWrapper.U1 .preview[lazy=error],
	.previewWrapper.U2 .preview[lazy=error]
	.previewWrapper.U4 .preview[lazy=error],
	.previewWrapper.US_PAGE_1 .preview[lazy=error],
	.previewWrapper.US_PAGE_2 .preview[lazy=error] {
		background: #fff url('../../../assets/img/bg-preview_customization.jpg') center no-repeat !important;
		background-size: 100% !important;
	}

	.previewWrapper .preview[lazy=loading] {
		background-size: 100px !important;
        background-position: 50% 50% !important;
	}

	.notification.is-info {
		background: #f5f5f5;
		color: #b70000;
		font-size: 15px;
	}

</style>
